import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { WAYS } from '../../data/staticContent';

const YouCan = () => {
  const { t } = useLanguage();

  return (
    <>
      {/* ── Ways to help ─────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">{t('youCan.title')}</h2>
            <div className="divider-brand-center"></div>
            <p className="section-subtitle">{t('youCan.subtitle')}</p>
          </div>

          <div className="row g-4">
            {WAYS.map(({ key, icon, iconClass }, i) => (
              <div className="col-lg-4 col-md-6" key={key}>
                <div className={`way-card anim-fade-up anim-delay-${i + 1}`}>
                  <div className={`way-icon ${iconClass}`}>
                    <i className={`bi ${icon}`}></i>
                  </div>
                  <div className="way-title">{t(`youCan.${key}Title`)}</div>
                  <p className="cf-card-text">{t(`youCan.${key}Desc`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA Banner ───────────────────────── */}
      <section className="cta-section">
        <div className="cta-decor cta-decor-1"></div>
        <div className="cta-decor cta-decor-2"></div>
        <div className="container text-center position-relative" style={{zIndex:1}}>
          <h2 className="cta-title">{t('youCan.ctaTitle')}</h2>
          <p className="cta-text">{t('youCan.ctaText')}</p>
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            <Link to="/contact" className="btn-white">
              <i className="bi bi-heart-fill"></i>
              {t('youCan.ctaDonate')}
            </Link>
            <Link to="/contact" className="btn-brand-outline">
              <i className="bi bi-people"></i>
              {t('youCan.ctaVolunteer')}
            </Link>
            <Link to="/contact" className="btn-brand-outline">
              <i className="bi bi-envelope"></i>
              {t('youCan.ctaContact')}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default YouCan;
